// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCardModalFoot_root__x13pq"};